import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Config from "config";
import { map } from "lodash";
import {
  Col,
  Row,
  Card,
  CardBody,
  Nav,
  NavItem,
  NavLink,
  CardTitle,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Dropdown,
  DropdownToggle,
  DropdownItem,
  DropdownMenu,
  Alert,
  Spinner,
} from "reactstrap";
import { ToastContainer } from "react-toastify";
import { useParams } from "react-router-dom";
import ModelCard from "components/Common/ModelCard";
import SectionCard from "components/Common/SectionCard";
import ImageCard from "components/Common/ImageCard";

import SouscriptionsCard from "components/Common/SouscriptionsCard";
import HmPaginated from "components/Common/hmPaginated";
import ImpressionsHmListModele from "components/Common/ImpressionsHmListModele";
import IdentificationCard from "./IdentificationCard";
import TableComponent from "./TableComponent";
import DeleteButton from "components/Common/DeleteButtonShow";
import LastModificationAlertShow from "./AlertShow";

const DetailModel = ({
  Titre,
  loading,
  setLoading,
  modeleData,
  impressionsData,
  activeTab,
  getListe,
  listeData,
  handleAction,
  handleTabClick,
  CustomNavTabs,
  fetchData,
  id,
  api,
  signature,
  wait,
  onTitleClick,

  // Function to fetch data
}) => {
  let linkState = { active: "" };

  if (activeTab == "details") {
    linkState.active = "details";
  } else if (activeTab == "contact") {
    linkState.active = "contact";
  } else {
    linkState.active = "details";
  }
  const navigate = useNavigate();
  const apiB = Config.backOffice.apiName;
  const token = localStorage.getItem("auth_token_" + apiB);

  const backUrl = Config.backOffice.url;
  const [modal, setModal] = useState(false);
  const [btnsecondary1, setBtnsecondary1] = useState(false);
  const toggleModal = () => setModal(!modal);
  const [get, setGet] = useState(false);
  const handleDropDownActionsClick = async (action) => {
    switch (action.action) {
      case "dupliquer":
        toast.success("Duplication en cours ...");
        try {
          const response = await fetch(
            `https://www.fluxod.com/${apiB}/${action.controlleur}/${id}/${action.action}`,
            {
              method: "GET",
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          const rep = await response.json();
          if (response.status == 200) {
            toast.success(rep.message);
            toast.info("Redirection en cours...");
            setTimeout(() => {
              try {
                navigate(`${backUrl}/${api}/${rep.id}`);
                setGet(true);
              } catch (error) {
                console.error("Erreur de navigation :", error);
              }
            }, 2000);
          } else {
            throw new Error(
              "La requête a échoué avec le statut " + response.status
            );
          }
        } catch (error) {
          toast.error(error.message);
        }
        break;

      default:
        toast.error("Aucune action configurée");
        break;
    }
  };
  useEffect(() => {
    fetchData();
    getListe();
  }, [signature, get]);
  useEffect(() => {
    if (wait === 0) {
      setLoading(false);
      console.log("test finished");
    }
  }, [wait]);
  function extractSegment(url) {
    const baseUrl = `${backUrl}/`;
    const editSegment = "/edit";

    // Check if the URL starts with the base URL and ends with the edit segment
    if (url.startsWith(baseUrl) && url.endsWith(editSegment)) {
      // Extract the part of the URL between base URL and edit segment
      const start = baseUrl.length;
      const end = url.length - editSegment.length;
      return url.substring(start, end);
    }

    return null;
  }
  const lastId = localStorage.getItem("lastId");
  const previousPath = localStorage.getItem("previousPath_" + apiB);

  const extractedText = extractSegment(previousPath);

  return (
    <React.Fragment>
      <div className="page-content" style={{ fontFamily: "sans-serif" }}>
        {previousPath == `${backUrl}/${extractedText}/edit` ? (
          <LastModificationAlertShow path={extractedText} />
        ) : null}
        <div className="container-fluid">
          <Row>
            <Col lg="12">
              <Card>
                <CardBody className="border-bottom">
                  <div className="d-flex align-items-center">
                    <h5
                      className="mb-0 card-title flex-grow-1"
                      style={{ fontWeight: "bold", display: "flex" }}
                    >
                      <Link
                        to={onTitleClick ? "#" : `${backUrl}/${api}/`}
                        onClick={onTitleClick || undefined}
                        style={{
                          color: "#555B21",
                          textDecoration: "underline !important",
                        }}
                      >
                        {Titre}
                      </Link>
                      <i className="bx bx-caret-right"></i>{" "}
                      {!loading ? (
                        modeleData.sil
                      ) : (
                        <>
                          <span
                            className="placeholder col-3"
                            style={{ height: "1em" }}
                          ></span>
                        </>
                      )}
                    </h5>
                  </div>
                  <Alert color="warning" isOpen={true}>
                    <div className="d-flex align-items-center">
                      <i className="mdi mdi-alert-outline"></i>
                      <span>
                        <strong>
                          Astuce : Pour importer un document Word :
                        </strong>
                        <ul className="mb-0 mt-1">
                          <li>
                            Sauvegardez le au format "Web Page Filtered" (HTML)
                          </li>
                          <li>
                            Ouvrez le avec un éditeur de texte type Bloc Note
                          </li>
                          <li>Copiez le contenu dans le presse papier</li>
                          <li>
                            Collez le dans le modèle Fluxod au format HTML
                            (Bouton HTML dans la barre de menu de l'éditeur)
                          </li>
                        </ul>
                      </span>
                    </div>
                  </Alert>

                  <div className="d-flex justify-content-end">
                    <div className="d-flex align-items-end">
                      {modeleData?.can_edit ? (
                        <Link
                          to={`${backUrl}/${api}/${id}/edit`}
                          state={linkState}
                          className="btn btn-sm btn-primary"
                        >
                          <i className="bx bx-edit-alt"></i>Modifier
                        </Link>
                      ) : null}
                      &nbsp; &nbsp;
                      {modeleData?.can_destroy ? (
                        <DeleteButton
                          url={`https://www.fluxod.com/${apiB}/${api}/${id}`}
                        />
                      ) : null}{" "}
                      {modeleData?.actions?.length > 0 ? (
                        <>
                          <>
                            &nbsp; &nbsp;
                            <Dropdown
                              isOpen={btnsecondary1}
                              toggle={() => setBtnsecondary1(!btnsecondary1)}
                            >
                              <DropdownToggle
                                tag="button"
                                className="btn btn-sm btn-secondary"
                              >
                                Actions <i className="mdi mdi-chevron-down" />
                              </DropdownToggle>
                              <DropdownMenu>
                                {modeleData?.actions.map((value, index) => (
                                  <>
                                    <DropdownItem
                                      onClick={() =>
                                        handleDropDownActionsClick(value.action)
                                      }
                                    >
                                      {value.label}
                                    </DropdownItem>
                                  </>
                                ))}
                              </DropdownMenu>
                            </Dropdown>
                          </>
                        </>
                      ) : null}
                    </div>
                  </div>
                </CardBody>
                {CustomNavTabs()}
                <CardBody>
                  {activeTab === "details" && (
                    <div>
                      {!loading ? (
                        <>
                          <Row>
                            <Col sm="6">
                              {modeleData?.detail_publipostage?.[
                                "Caractéristiques"
                              ] ? (
                                <ModelCard
                                  title="Caractéristiques"
                                  details={
                                    modeleData?.detail_publipostage?.[
                                      "Caractéristiques"
                                    ]
                                  }
                                  listeData={listeData}
                                />
                              ) : null}
                            </Col>
                            <Col sm="6">
                              {modeleData?.detail_publipostage?.[
                                "Filtres / Cumul"
                              ] ? (
                                <IdentificationCard
                                  title="Filtres / Cumul"
                                  details={
                                    modeleData?.detail_publipostage?.[
                                      "Filtres / Cumul"
                                    ]
                                  }
                                />
                              ) : null}

                              <IdentificationCard
                                title="Commentaires"
                                details={
                                  modeleData?.detail_publipostage?.Commentaires
                                }
                              />
                            </Col>
                          </Row>

                          <Row>
                            {modeleData?.detail_publipostage?.[
                              "Présentation / sortie"
                            ] ? (
                              <Col sm="6">
                                <IdentificationCard
                                  title="Présentation / sortie"
                                  details={
                                    modeleData?.detail_publipostage?.[
                                      "Présentation / sortie"
                                    ]
                                  }
                                />
                              </Col>
                            ) : null}
                            {modeleData?.detail_publipostage?.[
                              "Champs d'impression"
                            ] ? (
                              <Col sm="6">
                                <IdentificationCard
                                  title="Champs d'impression"
                                  details={
                                    modeleData?.detail_publipostage?.[
                                      "Champs d'impression"
                                    ]
                                  }
                                />
                                <ImageCard
                                  title="Images"
                                  images={
                                    modeleData?.detail_publipostage?.["Images"]
                                  }
                                />
                              </Col>
                            ) : null}
                            <Row>
                              <Col sm="12">
                                <IdentificationCard
                                  title="Contenu"
                                  details={
                                    modeleData?.detail_publipostage?.Contenu
                                  }
                                />
                              </Col>
                            </Row>
                            {modeleData?.detail_publipostage?.[
                              "Signature électronique"
                            ]?.Signataires ? (
                              <Row>
                                <Col sm="12">
                                  <TableComponent
                                    title="Signature électronique"
                                    header={
                                      modeleData?.detail_publipostage?.[
                                        "Signature électronique"
                                      ]?.Signataires?.header
                                    }
                                    data={
                                      modeleData?.detail_publipostage?.[
                                        "Signature électronique"
                                      ]?.Signataires?.data
                                    }
                                  />
                                </Col>
                              </Row>
                            ) : null}
                          </Row>
                        </>
                      ) : (
                        <div className="d-flex align-items-center justify-content-center gap-2 py-4">
                          <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                          <span>Chargement en cours...</span>
                        </div>
                      )}
                    </div>
                  )}

                  {activeTab === "impressions" && (
                    <div className="table-responsive">
                      {!loading ? (
                        <>
                          <ImpressionsHmListModele
                            title={impressionsData}
                            data={impressionsData.data}
                            header={impressionsData.header}
                            itemsPerPage={10}
                            modeleData={modeleData}
                          />
                        </>
                      ) : (
                        <div className="d-flex align-items-center justify-content-center gap-2 py-4">
                          <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                          <span>Chargement en cours...</span>
                        </div>
                      )}
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>

      <ToastContainer />
    </React.Fragment>
  );
};

export default DetailModel;
